export const adjustEditProfileData = data => {
  let newData = {
    user: {},
    role_id: data.role_id,
    company: {},
  };
  const user = data.user;
  const company = data.company;
  if (user.user_id) {
    newData.user.user_id = user.user_id;
  }
  if (user.lastname) {
    newData.user.lastname = user.lastname;
  }
  if (user.name) {
    newData.user.name = user.name;
  }
  if (user.patronymic) {
    newData.user.patronymic = user.patronymic;
  }
  if (user.birth_date) {
    newData.user.birth_date = user.birth_date;
  }
  if (user.birth_place) {
    newData.user.birth_place = user.birth_place;
  }
  if (user.sex_id) {
    newData.user.sex_id = user.sex_id;
  }
  if (user.citizenship_id) {
    newData.user.citizenship_id = user.citizenship_id;
  }
  if (user.email) {
    newData.user.email = user.email;
  }
  if (user.photo) {
    newData.user.photo = user.photo;
  }
  if (user.identity_document_id) {
    newData.user.identity_document_id = user.identity_document_id;
  }
  if (user.identity_document_series) {
    newData.user.identity_document_series = user.identity_document_series;
  }
  if (user.identity_document_number) {
    newData.user.identity_document_number = user.identity_document_number;
  }
  if (user.driver_license_id) {
    newData.user.driver_license_id = user.driver_license_id;
  }
  if (company.company_id) {
    newData.company.company_id = company.company_id;
  }
  if (company.subject_id) {
    newData.company.subject_id = company.subject_id;
  }
  if (company.name_legal) {
    newData.company.name_legal = company.name_legal;
  }
  if (company.address_legal) {
    newData.company.address_legal = company.address_legal;
  }
  if (company.registraton_date) {
    newData.company.registraton_date = company.registraton_date;
  }
  if (company.inn) {
    newData.company.inn = company.inn;
  }
  if (company.kpp) {
    newData.company.kpp = company.kpp;
  }
  if (company.ogrn) {
    newData.company.ogrn = company.ogrn;
  }
  if (company.eio) {
    newData.company.eio = company.eio;
  }
  if (company.address_fact) {
    newData.company.address_fact = company.address_fact;
  }
  if (company.ogrnip) {
    newData.company.ogrnip = company.ogrnip;
  }
  if (company.phone) {
    newData.company.phone = company.phone;
  }
  if (company.email) {
    newData.company.email = company.email;
  }
  if (company.site) {
    newData.company.site = company.site;
  }
  if (company.nds) {
    newData.company.nds = company.nds;
  }
  if (company.lastname) {
    newData.company.lastname = company.lastname;
  }
  if (company.name) {
    newData.company.name = company.name;
  }
  if (company.patronymic) {
    newData.company.patronymic = company.patronymic;
  }
  if (company.birth_date) {
    newData.company.birth_date = company.birth_date;
  }
  if (company.status) {
    newData.company.status = company.status;
  }
  if (company.company_type_id) {
    newData.company.company_type_id = company.company_type_id;
  }
  if (company.tariff_type_id) {
    newData.company.tariff_type_id = company.tariff_type_id;
  }
  if (company.tariff_fee_period_id) {
    newData.company.tariff_fee_period_id = company.tariff_fee_period_id;
  }
  if (company.tariff_purchase_date) {
    newData.company.tariff_purchase_date = company.tariff_purchase_date;
  }
  if (company.tariff_end_date) {
    newData.company.tariff_end_date = company.tariff_end_date;
  }
  if (company.teleportos_account_id) {
    newData.company.teleportos_account_id = company.teleportos_account_id;
  }
  if (company.cashier_account_id) {
    newData.company.cashier_account_id = company.cashier_account_id;
  }
  if (company.passport_data) {
    newData.company.passport_data = company.passport_data;
  }
  return newData;
};
